<template>
  <div>
    <el-menu
      :default-active="this.$router.path"
      router
      unique-opened
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
    >
      <el-radio-group v-model="isCollapse">
        <el-radio-button :label="false">展开</el-radio-button>
        <el-radio-button :label="true">收起</el-radio-button>
      </el-radio-group>
      <el-submenu :index="String(item.id)" v-for="(item,i) in navList" :key="i">
        <template slot="title">
          <i :class="item.cssClass"></i>
          <span slot="title">{{item.name}}</span>
        </template>
        <el-menu-item-group v-for="(itema,index) in item.children" :key="index">
          <el-menu-item :index="itema.url">{{itema.name}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isCollapse: false,
      navList: [],
    };
  },
  mounted() {
    this.$http.post(this.$getaxiosurl("/user/user/getUserMenu")).then((res) => {
      if (res.data.code == "00100") {
        this.navList = [];
        this.navList = res.data.data;
      } else {
        this.$message({
          message: res.data.msg,
          type: "success",
          duration: 8000,
        });
      }
    });
  },
  methods: {},
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-menu {
  box-shadow: 0 2px 2px rgba(10, 16, 20, 0.24), 0 0 2px rgba(10, 16, 20, 0.12);
  border: 0px;
}
ul {
  height: 100%;
}
</style>